import { render, staticRenderFns } from "./MediaGallery.vue?vue&type=template&id=09d952e4&scoped=true&"
import script from "./MediaGallery.vue?vue&type=script&lang=js&"
export * from "./MediaGallery.vue?vue&type=script&lang=js&"
import style0 from "./MediaGallery.vue?vue&type=style&index=0&id=09d952e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d952e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09d952e4')) {
      api.createRecord('09d952e4', component.options)
    } else {
      api.reload('09d952e4', component.options)
    }
    module.hot.accept("./MediaGallery.vue?vue&type=template&id=09d952e4&scoped=true&", function () {
      api.rerender('09d952e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/MediaGallery.vue"
export default component.exports